<template>
  <!-- 头部整体盒子 -->
  <div id="header" class="container-fuild">
    <!-- 头部顶部 -->
    <!-- 电脑导航 -->
    <div class="header-nav hidden-xs">
      <!-- 导航logo -->
      <!-- <div :class="{img_hover: hover_flag}" class="header-nav-logo" class="web_icon" @click="goHome"> -->
      <div class="header-nav-logo web_icon" @click="goHome">
        <img src="@/assets/img/logo.png" style="left: 5%" />
        <div style="margin-left: 80px">
          <span class="title"><h3>武汉南图科技有限公司</h3></span>
        </div>
      </div>
      <!-- <span class="title"><h3>武汉南图科技有限公司</h3></span> -->
      <!-- 导航内容 -->
      <ul class="header-nav-wrapper">
        <li
          v-for="(item, index) in navList"
          :key="index"
          :class="index == navIndex ? 'active' : ''"
          @click="navClick(index, item.name)"
        >
          <router-link :to="item.path">
            {{ item.name }}
            <span
              v-if="item.children.length > 0"
              class="glyphicon glyphicon-menu-down"
            ></span>
            <i class="underline"></i>
          </router-link>
          <dl
            v-if="item.children.length > 0"
            class="left-aligned"
            style="left: 0 !important"
          >
            <dt v-for="(i, n) in item.children" :key="n">
              <router-link :to="i.path">{{ i.name }}</router-link>
            </dt>
          </dl>
        </li>
      </ul>
    </div>
    <!-- 手机导航 -->
    <div class="header-nav-m container-fuild visible-xs header-nav">
      <div class="header-nav-logo web_icon" @click="goHome">
        <img src="@/assets/img/logo.png" />
        <div style="float: right">
          <span class="title"><h3>武汉南图科技有限公司</h3></span>
        </div>
      </div>
      <ul class="header-nav-wrapper">
        <li
          v-for="(item, index) in navList"
          :key="index"
          :class="index == navIndex ? 'active' : ''"
          @click="navClick(index, item.name)"
        >
          <router-link :to="item.path">
            {{ item.name }}
            <span
              v-if="item.children.length > 0"
              class="glyphicon glyphicon-menu-down"
            ></span>
            <i class="underline"></i>
          </router-link>
          <dl v-if="item.children.length > 0" class="left-aligned">
            <dt v-for="(i, n) in item.children" :key="n">
              <router-link :to="i.path">{{ i.name }}</router-link>
            </dt>
          </dl>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "Header",
  data() {
    return {
      navIndex: sessionStorage.getItem("navIndex")
        ? sessionStorage.getItem("navIndex")
        : 0,
      menuName: "首页",
      menuClass: "glyphicon glyphicon-menu-down",
      navList: [
        {
          name: "首页",
          path: "/",
          children: [],
        },
        {
          name: "DeepSeek",
          path: "/AI/chatDeepSeek", // 直接指向有效路径
          children: [],
        },
        {
          name: "软件产品",
          path: "/software/panoVR",
          children: [
            {
              name: "南图全景系列",
              path: "/software/panoVR",
            },
            {
              path: "/software/digital3D",
              name: "南图三维数字化平台",
            },
            {
              path: "/software/gisPublicPlatform",
              name: "南图地理信息公共平台",
            },
            {
              path: "/software/3dPlan",
              name: "三维路径规划",
            },
            {
              path: "/software/3DModel",
              name: "三维模型展示",
            },
          ],
        },
        {
          name: "解决方案",
          path: "/solution",
          children: [
            {
              name: "地理信息公共平台",
              path: "/solution/pc",
            },
            {
              id: "section-2",
              name: "AE辅助生产工具",
              path: "/solution/AE",
            },
            {
              path: "/solution/ServiceDetail",
              id: "section-3",
              name: "南图GIS服务平台系列",
            },
            {
              path: "/solution/ServiceDetail",
              id: "section-4",
              name: "南图智慧平台系列",
            },
          ],
        },
        {
          name: "公司介绍",
          path: "/company",
          children: [
            {
              name: "公司简介",
              path: "/company/Introduction",
            },
            {
              name: "企业资质",
              path: "/company/qualifications",
            },
            {
              name: "工作机会",
              path: "/company/jobchance",
              children: [],
            },
          ],
        },

        {
          name: "联系我们",
          path: "/contactus",
          children: [],
        },
      ],
    };
  },
  methods: {
    navClick(index, name, item, path) {
      //debugger;
      this.navIndex = index;
      sessionStorage.setItem("navIndex", index);
      this.menuName = name;
      // var ua = window.navigator.userAgent.toLowerCase();
      //       if (!(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent))) {
      //          window.location.href = "http://192.168.0.103:8888/solution/ss1#/solution/ss2";
      //       }
      //       else if (ua.indexOf("iphone") > 0 || ua.indexOf("android") > 0) {
      //          window.location.href = "http://192.168.0.103:8888/solution/ss1#/solution/ss1";
      //       }
    },
    // navClick(){(function(){
    //         var ua = window.navigator.userAgent.toLowerCase();
    //         if (!(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent))) {
    //            window.location.href = "/solution/ss2";
    //         }
    //         else if (ua.indexOf("iphone") > 0 || ua.indexOf("android") > 0) {
    //            window.location.href = "/solution/ss1";
    //         }
    //         }());
    //       },
    goHome() {
      this.$router.push("/home");
      this.active = "首页";
      // this.navClick(0, '首页');
    },
    menuClick() {
      if (this.menuClass == "glyphicon glyphicon-menu-down") {
        this.menuClass = "glyphicon glyphicon-menu-up";
      } else {
        this.menuClass = "glyphicon glyphicon-menu-down";
      }
    },
  },
};
</script>

<style scoped>
/* 顶部 */
#header {
  background: #f4f4f4;
  transition: all ease 0.6s;
}
#header .header-top {
  height: 50px;
  color: #fff;
  font-size: 12px;
  line-height: 50px;
  background: #474747;
}
/* 顶部的图标 */
#header .header-top span {
  margin: 0 8px;
}
/* 导航栏 */
#header .header-nav {
  height: 110px;
}
/* 导航栏logo */
#header .header-nav .header-nav-logo {
  width: 350px;
  height: 100%;
  float: left;
  position: relative;
}
/* 导航栏logo图片 */
#header .header-nav .header-nav-logo img {
  width: 64px;
  height: 64px;
  position: absolute;
  top: 0;
  left: 0;
  right: 100;
  bottom: 0;
  margin: auto;
}
/* 导航栏 导航容器 */
#header .header-nav-fixed .header-nav-wrapper {
  line-height: 50px;
}
#header .header-nav .header-nav-wrapper {
  line-height: 110px;
  float: right;
  display: table-cell;
  margin: 0 auto;
  padding-right: 25px;
  /* max-width: 800px;
   /* transform: translateX(400px); */
}
/* 导航栏 每个导航 */
#header .header-nav .header-nav-wrapper > li {
  float: left;
  margin: 0 15px;
  position: relative;
}
/* 导航栏 每个导航下面的 a 链接 */
#header .header-nav .header-nav-wrapper > li > a {
  color: #000;
  font-size: 15px;
  font-weight: bold;
  padding: 15px 0;
  position: relative;
}

/* 导航栏 每个导航下面的 a 链接的下划线 */
#header .header-nav .header-nav-wrapper > li > a > i {
  display: block;
  position: absolute;
  bottom: -2px;
  left: 50%;
  width: 0;
  height: 2px;
  opacity: 0;
  transition: all 0.6s ease;
  background-color: #1e73be;
}
/* 导航栏 每个导航下面的 a 链接的右侧小三角 */
#header .header-nav .header-nav-wrapper > li > a > span {
  font-size: 12px;
  transition: transform ease 0.5s;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover {
  color: #1e73be;
  text-decoration: none;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去下划线的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover .underline {
  opacity: 1;
  width: 100%;
  left: 0;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去三角标的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover span {
  transform: rotate(180deg);
}
/* 导航栏 每个导航下面的 a 链接 鼠标点击后的样式 */
#header .header-nav .header-nav-wrapper > li.active > a {
  color: #1e73be;
  text-decoration: none;
  border-bottom: 2px solid #1e73be;
}
/* 导航栏 每个导航下面的二级导航容器 */
#header .header-nav .header-nav-wrapper > li > dl {
  display: none;
  position: absolute;
  width: 168px;
  top: 80%;
  left: 0;
  z-index: 999999;
  box-shadow: 0 0 3px 1px #ccc;
  background: #fff;
}
/* 导航栏 每个导航下面的二级导航容器的每个导航 */
#header .header-nav .header-nav-wrapper > li > dl > dt {
  width: 100%;
  padding: 10px;
  border-bottom: 1px solid #ccc;
}
/* 导航栏 每个导航下面的二级导航容器的样式 */
#header .header-nav .header-nav-wrapper > li > dl.left-aligned {
  left: 0 !important;
}
/* 导航栏 每个导航下面的二级导航容器的每个导航 当鼠标滑上时的样式*/
#header .header-nav .header-nav-wrapper > li > dl > dt > a:hover {
  text-decoration: none;
}
/* 导航栏 滑上一级导航显示二级导航 */
#header .header-nav .header-nav-wrapper > li:hover dl {
  display: block;
}
#header .header-nav .header-nav-wrapper > li > dl > dt:hover {
  cursor: pointer;
  background: #ccc;
}
@media screen and (max-width: 997px) {
  #header .header-nav-m {
    position: relative;
  }
  /* 导航栏logo容器 */
  #header .header-nav-m .header-nav-m-logo {
    height: 80px;
    position: relative;
  }
  /* 导航栏logo图片 */
  #header .header-nav-m .header-nav-m-logo img {
    width: 95px;
    height: 45px;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
  }
  /* 导航栏  菜单容器 */
  #header .header-nav-m .header-nav-m-menu {
    color: #fff;
    height: 50px;
    font-size: 20px;
    line-height: 50px;
    background: #474747;
    position: relative;
  }
  /* 导航栏 菜单图标 */
  #header .header-nav-m .header-nav-m-menu-wrapper {
    position: absolute;
    top: 50%;
    right: 20px;
    margin-top: -20px;
    width: 50px;
    height: 40px;
    color: #fff;
    z-index: 999999;
    font-size: 12px;
  }
  /* 导航栏 */
  #header .header-nav-m .header-nav-m-wrapper {
    position: absolute;
    top: 50px;
    left: 0;
    width: 100%;
    background: #474747;
    z-index: 9999999;
  }
  /* 导航栏 每个导航 */
  #header .header-nav-m .header-nav-m-wrapper > li {
    height: 40px;
    line-height: 40px;
    border-bottom: 1px solid #ccc;
  }
  /* 导航栏 每个导航下面的 a 链接 */
  #header .header-nav-m .header-nav-m-wrapper > li > a {
    color: #fff;
    font-size: 15px;
    font-weight: bold;
    padding: 15px 0;
    position: relative;
  }
  /* 导航栏 每个导航下面的 a 链接的右侧小三角 */
  #header .header-nav .header-nav-wrapper > li > a > span {
    font-size: 10px;
  }
}
</style>

<style lang="scss" scoped>
.title {
  font-size: 0.875rem;
  border-left: 1px solid #ffffff;
  padding-left: 10px;
  margin-left: 80px;
  color: #009688;
  line-height: 1;
}
.img_hover:hover {
  &::before {
    content: "";
    height: 555px;
    width: 100%;
    position: absolute;
    left: 0%;
    top: 0;
    background-color: transparent;
    background-image: -webkit-linear-gradient(
      -30deg,
      transparent 30%,
      #fff 50%,
      transparent 70%
    ); /*设置渐变的背景，按对角线渐变*/
    background-blend-mode: hard-light; /*设置背景为混合模式下的强光模式*/
    background-size: 200%;
    animation: shine 5s forwards; /*给背景添加动画改变位置*/
  }
}
.web_icon {
  img {
    position: absolute;
    z-index: inherit;
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue